import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter, map, of, switchMap, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoutingLoaderService {
  private readonly router = inject(Router);

  readonly isNavigating = toSignal(
    this.router.events.pipe(
      filter(
        (e) =>
          e instanceof NavigationStart ||
          e instanceof NavigationEnd ||
          e instanceof NavigationCancel ||
          e instanceof NavigationError
      ),
      map((e) => e instanceof NavigationStart),
      // Only delay showing the spinner — hide it immediately.
      // switchMap cancels the timer if navigation completes before 150ms,
      // so cached/instant routes never trigger the spinner at all.
      switchMap((isStart) => (isStart ? timer(150).pipe(map(() => true)) : of(false)))
    ),
    { initialValue: false }
  );
}
